import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Card, { CardHeader, CardContent } from 'material-ui/Card';
import { Form, Input, Icon, Button, message } from 'antd';
import axios from 'axios';
import validator from '../utils/basicValidator';
import { baseUrl } from '../utils/globals';
import './Login.css';

const FormItem = Form.Item;

const validationRules = {
  mobile: 'required|mobile',
  password: 'required',
};

class Login extends Component {
  state = {
    mobile: {
      validateStatus: null,
      errorMsg: null,
      value: '',
    },
    password: {
      validateStatus: null,
      errorMsg: null,
      value: '',
    },
    submittingForm: false,
  };

  handleFormInputChange = (field, event) => {
    const { value } = event.target;
    const error = validator(value, validationRules[field]);
    let validateStatus = 'success';
    let errorMsg = null;
    if (error) {
      validateStatus = 'error';
      errorMsg = error;
    }
    this.setState({
      [field]: {
        validateStatus,
        errorMsg,
        value,
      },
    });
  };

  handleFormSubmit = () => {
    this.setState({
      submittingForm: true,
    });
    const formData = {};
    let hasError = false;
    Object.keys(validationRules).forEach((field) => {
      const { value } = this.state[field];
      const error = validator(value, validationRules[field]);
      formData[field] = value;
      if (error) {
        hasError = true;
        this.setState({
          [field]: {
            validateStatus: 'error',
            errorMsg: error,
            value,
          },
        });
      }
    });
    if (hasError) {
      this.setState({
        submittingForm: false,
      });
      return;
    }
    axios.post(`${baseUrl}/auth/login`, formData)
      .then((response) => {
        this.setState({
          submittingForm: false,
        });
        const user = response.data;
        localStorage.setItem('user', JSON.stringify(user));
        localStorage.setItem('userApiToken', user.apiToken);
        this.props.history.push('/app');
      })
      .catch((error) => {
        this.setState({
          submittingForm: false,
        });
        message.error(error.response.data.error);
      });
  };

  render() {
    const { mobile, password } = this.state;
    return (
      <div id="login-form-container">
        <Card raised id="login-form-card">
          <CardHeader title="Bizminder Employee Login" />
          <CardContent>
            <Form>
              <FormItem required hasFeedback validateStatus={mobile.validateStatus} help={mobile.errorMsg}>
                <Input
                  prefix={<Icon type="mobile" style={{ color: 'rgba(0,0,0,.25)' }} />}
                  placeholder="Mobile"
                  value={mobile.value}
                  onChange={(e) => this.handleFormInputChange('mobile', e)}
                />
              </FormItem>
              <FormItem required hasFeedback validateStatus={password.validateStatus} help={password.errorMsg}>
                <Input
                  prefix={<Icon type="lock" style={{ color: 'rgba(0,0,0,.25)' }} />}
                  placeholder="Password"
                  type="password"
                  value={password.value}
                  onChange={(e) => this.handleFormInputChange('password', e)}
                  onPressEnter={this.handleFormSubmit}
                />
              </FormItem>
              <FormItem>
                <Button
                  type="primary"
                  size="large"
                  className="full-width"
                  htmlType="button"
                  onClick={this.handleFormSubmit}
                  loading={this.state.submittingForm}
                >
                  Log in
                </Button>
              </FormItem>
            </Form>
          </CardContent>
        </Card>
      </div>
    );
  }
}

Login.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
};

export default Login;



// WEBPACK FOOTER //
// ./src/pages/Login.jsx